import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import useWidth from '../../../Hooks/useWidth';
import Hidden from '../../DesignSystem/Hidden';

const DEFAULT_HEIGHT = 72;

function StickyFooterWrapper({ height = DEFAULT_HEIGHT, children }: any) {
  const isMobile = useWidth('down', 'sm');

  useEffect(() => {
    // make sure styicky element doesn't hide footer
    if (children && isMobile) {
      window.document.body.style.marginBottom = `${height}px`;
    } else {
      window.document.body.style.marginBottom = '0px';
    }
  }, [isMobile]);

  return (
    <Hidden breakpoint="md" direction="up">
      <Box
        sx={{
          backgroundColor: 'background.paper',
          width: '100%',
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          padding: (theme: any) => theme.spacing(1.5, 2),
          boxShadow: '0px -1px 2px rgba(0, 0, 0, 0.18)',
          zIndex: (theme: any) => theme.zIndex.appBar,
        }}
      >
        {children}
      </Box>
    </Hidden>
  );
}

export default StickyFooterWrapper;
